import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 7l-6.5 6.5a1.5 1.5 0 0 0 3 3l6.5 -6.5a3 3 0 0 0 -6 -6l-6.5 6.5a4.5 4.5 0 0 0 9 9l6.5 -6.5","key":"svg-0"}]]

/**
 * IconPaperclip
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcGFwZXJjbGlwIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNSA3bC02LjUgNi41YTEuNSAxLjUgMCAwIDAgMyAzbDYuNSAtNi41YTMgMyAwIDAgMCAtNiAtNmwtNi41IDYuNWE0LjUgNC41IDAgMCAwIDkgOWw2LjUgLTYuNSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/paperclip
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconPaperclip = createReactComponent('outline', 'paperclip', 'Paperclip', __iconNode);

export default IconPaperclip;